export const darkScrollbarStyles = {
    '*::-webkit-scrollbar': {
        width: '8px',
        height: '8px',
    },
    '*::-webkit-scrollbar-track': {
        background: 'transparent',
    },
    '*::-webkit-scrollbar-thumb': {
        background: 'rgba(255,255,255,0.10)',
        borderRadius: '100px',
        '&:hover': {
            background: 'rgba(255,255,255,0.20)',
        },
    },
    '*::-webkit-scrollbar-corner': {
        background: 'transparent',
    },
};
export const lightScrollbarStyles = {
    '*::-webkit-scrollbar': {
        width: '8px',
        height: '8px',
    },
    '*::-webkit-scrollbar-track': {
        background: 'transparent',
    },
    '*::-webkit-scrollbar-thumb': {
        background: 'rgba(0,0,0,0.10)',
        borderRadius: '100px',
        '&:hover': {
            background: 'rgba(0,0,0,0.20)',
        },
    },
    '*::-webkit-scrollbar-corner': {
        background: 'transparent',
    },
};
